/**********************************| Document Ready start |****************************/
$(document).ready(function () {
  brandslider();
  singlebrandslider();
  filterAcco();
  $('.contact').appendTo('.contact_form_copy');
  
});
/**********************************| Document Ready start |****************************/
/**********************************| Window Load Start |****************************/
$(window).on('load',function () {
    
});
/**********************************| Window Load End |****************************/
/**********************************| Window Resize Start |****************************/
$(window).resize(function () {
   setTimeout(function() {
    
   },360);	
});
/**********************************| Window Resize End |****************************/
/**********************************| Window Scroll Start |****************************/
$(window).scroll(function(){
  setTimeout(function() {
    
  },350);
});
/**********************************| Window Scroll End |****************************/ 
function brandslider(){
	if ($('.brandslider').length > 0) {
		$('.brandslider').slick({
          rows: 2,
          dots: true,
          arrows: false,
          infinite: true,
          speed: 300,
          slidesToShow: 6,
          slidesToScroll: 6,
          responsive: [
              {
                breakpoint: 1025,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                }
              },
              {
                breakpoint: 360,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
              }
            ]
		});
	}
}

function singlebrandslider(){
	if ($('.singlebrand-slider').length > 0) {
		$('.singlebrand-slider').slick({
          rows: 1,
          dots: true,
          arrows: false,
          infinite: true,
          speed: 300,
          slidesToShow: 6,
          slidesToScroll: 6,
          responsive: [
              {
                breakpoint: 1025,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                }
              },
              {
                breakpoint: 360,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
              }
            ]
		});
	}
}

function filterAcco(){
  $('.sitemaptitle').click(function(){
    $(this).next().slideToggle();
    $(this).toggleClass('sitemap-open');
  });
}

/*-----------| 08. Custom Scroll  |-----------*/

/*-----------| Read More Content  |-----------*/
document.addEventListener('DOMContentLoaded', () => {
  const moreLess = document.querySelectorAll('.more-less');
  const moreText = document.querySelector('.more-text');

  const style = document.createElement('style');
  style.textContent = ".more-less {cursor:pointer}.more-text {opacity: 0;max-height: 0;transition: 1s} .more-text.open {opacity: 1;max-height: 3000px;height:100%}";
  document.head.appendChild(style);

  moreLess.forEach(item => {
    item.addEventListener('click', () => {
      moreText.classList.toggle('open');

      const buttonText = moreLess[0].textContent.includes('Read More') ? 'Show Less' : 'Read More';
      moreLess.forEach(elem => {
        elem.textContent = buttonText;
      });
    });
  });
});

